import {
  EnhancedForm,
  IdentityField,
  AutocompleteAdapter,
  TextFieldAdapter,
  DatePickerAdapter
} from 'components/enhanced';
import { required } from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';

interface MedicalServicesFormProp {
  onSubmitCreate: any;
  exams: any;
  setExam: any;
  laboratories: any;
  setLab: any;
  workstations: any;
}

export const MedicalServicesForm = ({
  onSubmitCreate,
  exams,
  setExam,
  laboratories,
  setLab,
  workstations
}: MedicalServicesFormProp) => {
  const translationPrefix = 'pages.medical-services.list';
  const { t } = useTranslation();

  return (
    <EnhancedForm onSubmit={onSubmitCreate} autoStyleLayout columns={6}>
      <IdentityField
        gridSpan={3}
        name="exam"
        component={AutocompleteAdapter}
        options={exams}
        setValue={setExam}
        label={t(`${translationPrefix}.entity.exam`)}
        type="text"
        optionLabel="description"
        optionValue="code"
        validate={required}
        required
      />

      <IdentityField
        gridSpan={1}
        name="laboratory"
        component={AutocompleteAdapter}
        options={laboratories}
        setValue={setLab}
        label={t(`global.laboratory`)}
        type="text"
        optionValue="code"
        validate={required}
        required
      />

      <IdentityField
        gridSpan={2}
        name="request_laboratory"
        component={TextFieldAdapter}
        label={t(`global.request_laboratory`)}
        type="text"
        required
      />

      <IdentityField
        gridSpan={3}
        name="req_department"
        component={TextFieldAdapter}
        label={t(`global.request_department`)}
        type="text"
      />

      <IdentityField
        gridSpan={3}
        name="workstation"
        component={AutocompleteAdapter}
        options={workstations}
        label={t(`global.workstation`)}
        type="text"
        optionValue="code"
      />

      <IdentityField
        gridSpan={2}
        name="date"
        component={DatePickerAdapter}
        label={t(`${translationPrefix}.entity.service_date`)}
        type="date"
        validate={required}
        required
      />

      <IdentityField
        gridSpan={2}
        name="request_date"
        component={DatePickerAdapter}
        label={t(`${translationPrefix}.entity.request_date`)}
        type="date"
        validate={required}
        required
      />

      <IdentityField
        gridSpan={2}
        name="quantity"
        component={TextFieldAdapter}
        label={t(`${translationPrefix}.entity.quantity`)}
        type="number"
        initialValue="1"
        required
      />
    </EnhancedForm>
  );
};
